import { render, staticRenderFns } from "./LoginFactoryStatistics.vue?vue&type=template&id=715b48b2&scoped=true&"
import script from "./LoginFactoryStatistics.vue?vue&type=script&lang=js&"
export * from "./LoginFactoryStatistics.vue?vue&type=script&lang=js&"
import style0 from "./LoginFactoryStatistics.vue?vue&type=style&index=0&id=715b48b2&scoped=true&lang=css&"
import style1 from "./LoginFactoryStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b48b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('715b48b2')) {
      api.createRecord('715b48b2', component.options)
    } else {
      api.reload('715b48b2', component.options)
    }
    module.hot.accept("./LoginFactoryStatistics.vue?vue&type=template&id=715b48b2&scoped=true&", function () {
      api.rerender('715b48b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hhemp/basedata/LoginFactoryStatistics.vue"
export default component.exports